export const TOOLKIT_REFERENCE_VIEW_PROPERTY_ID_PREFIX = 'tkrv:';
